export default "__VITE_ASSET__BpRDezzK__"